import { Link } from "react-router-dom";

import { cn } from "@/lib/utils";

interface BrandProps {
  /** Compact = sidebar variant; otherwise the marketing wordmark. */
  compact?: boolean;
  /** Set to `null` to render without the wrapping <Link>. */
  href?: string | null;
  className?: string;
}

/**
 * knode-os wordmark. Inline SVG so we don't need a `/public` asset and the
 * mark recolors with `currentColor` (handy in dark mode and inside CTAs).
 */
export function Brand({ compact = false, href = "/", className }: BrandProps) {
  const size = compact ? 22 : 28;
  const inner = (
    <span
      className={cn(
        "inline-flex items-center gap-2.5",
        compact ? "text-base" : "text-lg",
        className,
      )}
    >
      <span className="inline-flex items-center justify-center rounded-xl bg-[hsl(var(--clay))]/15 p-1.5 text-clay">
        <svg
          width={size}
          height={size}
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <title>knode-os</title>
          {/* Stylized K — a node with two outgoing edges. */}
          <circle cx="9" cy="16" r="2.5" fill="currentColor" />
          <circle cx="23" cy="7" r="2.5" fill="currentColor" />
          <circle cx="23" cy="25" r="2.5" fill="currentColor" />
          <path
            d="M9 16 L23 7 M9 16 L23 25"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </span>
      <span className="font-semibold tracking-tight text-foreground">
        knode<span className="text-muted-foreground/70">-os</span>
      </span>
    </span>
  );

  if (href === null) return inner;
  return (
    <Link to={href} className="no-underline" aria-label="knode-os home">
      {inner}
    </Link>
  );
}
